var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8042 11.6306L11.3259 0.152365C11.2279 0.0545389 11.095 -0.000243636 10.9566 9.29098e-07H1.56526C1.27711 -0.000537114 1.04311 0.23268 1.04257 0.520827C1.04233 0.659739 1.0975 0.793027 1.19587 0.891147L12.3058 12L1.19587 23.1089C0.99185 23.3123 0.991459 23.6427 1.19494 23.8467C1.29306 23.9451 1.42634 24.0002 1.56526 24H10.9566C11.095 24.0002 11.2279 23.9455 11.3259 23.8476L22.8042 12.3694C23.0082 12.1659 23.0086 11.8355 22.8051 11.6315L22.8042 11.6306Z",
    fill: "#BAE3F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ee561f018a5eedde3e5fcc376daa3fd9.svg";
export { ForwardRef as ReactComponent };